import { render, staticRenderFns } from "./speaker-selector.vue?vue&type=template&id=4e6f0991"
import script from "./speaker-selector.vue?vue&type=script&lang=ts"
export * from "./speaker-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports